<template>
	<div>
		<div class="btn">
			<div class="jiams tj">
				<div>请选择设备：</div>
				<Select v-model="query.macs" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo">
				        <Option v-for="item in macs" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<div class="time tj">
				<div>请选择时间：</div>
				<div class="time-xz">
					<DatePicker type="datetime" placeholder="开始时间" v-model='kaishi' style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
					<div>--</div>
					<DatePicker type="datetime" placeholder="结束时间" v-model='jieshu' style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"  ></DatePicker>
				</div>
			</div>
			
			<Button type="info" @click="daochu">导出</Button>
		</div>
		<div class="tongji">
			<Tag size="large" color="orange">总金额:{{map.totalMoney}}元</Tag>
			<Tag size="large" color="green">微信:{{map.wechatMoney}}元</Tag>
			<Tag size="large" color="green">微信退款:{{map.wechatRefundMoney}}元</Tag>
			<Tag size="large" color="cyan">支付宝:{{map.alpayMoney}}元</Tag>
			<Tag size="large" color="cyan">支付宝退款:{{map.alpayRefundMoney}}元</Tag>
			<Tag size="large" color="blue">环保积分:{{map.xiaojieMoney}}元</Tag>
			<Tag size="large" color="blue">环保积分退款:{{map.xiaojieRefundMoney}}元</Tag>
			<!-- <Tag size="large" color="geekblue">小善积分:{{map.xiaoshanMoney}}元</Tag>
			<Tag size="large" color="geekblue">小善积分退款:{{map.xiaoshanRefundMoney}}元</Tag> -->
		
		</div>

		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button> 
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				kaishi:'2019-5-01 00:00:00',
				jieshu:'2019-06-31 00:00:00',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//商品列表
				comms: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [{
						title: '设备id',
						key: 'id',
						width:120,
						align:'center',
					},
					// {
					// 	title: '设备编号',
					// 	key: 'macCode',
					// 	width:100,
					// },
					// {
					// 	title: '加盟商',
					// 	key: 'allianceName',
					// 	width:150,
					// },
					{
						title: '设备地址',
						width:150,
						align:'center',
						key: 'address'
					},
					{
						title: '总金额',
						key: 'totalMoney',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.totalMoney)
						}
					},
					{
						title: '退款金额',
						key: 'refundMoney',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.refundMoney)
						}
					},
					{
						title: '抽成金额',
						key: 'rakeMoney',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.rakeMoney)
						}
					},
					
					{
						title: '微信',
						key: 'wechatMoney',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.wechatMoney)
						}
					},
					
					{
						title: '微信退款金额',
						key: 'wechatRefundMoney',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.wechatRefundMoney)
						}
					},
					
					{
						title: '支付宝',
						key: 'alpayMoney',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.alpayMoney)
						}
					},
					
					{
						title: '支付宝退款金额',
						key: 'alpayRefundMoney',
						width:200,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.alpayRefundMoney)
						}
					},
					// {
					// 	title: '小善积分',
					// 	key: 'xiaoshanMoney',
					// 	width:100,
					// 	render: (h, params) => {
					// 		return h("div",params.row.xiaoshanMoney)
					// 	}
					// },
					
					// {
					// 	title: '小善积分退款金额',
					// 	key: 'xiaoshanRefundMoney',
					// 	width:150,
					// 	render: (h, params) => {
					// 		return h("div",params.row.xiaoshanRefundMoney)
					// 	}
					// },
					{
						title: '环保积分',
						key: 'xiaojieMoney',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.xiaojieMoney)
						}
					},
					
					{
						title: '环保积分退款金额',
						width:150,
						align:'center',
						key: 'xiaojieRefundMoney',
						render: (h, params) => {
							return h("div",params.row.xiaojieRefundMoney)
						}
					},
					{
						title: '操作',
						slot: 'action',
						width: 100,
						align: 'center',
                        fixed: 'right'
					}
				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '10',
					//开始时间
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
					macs:[],//设备信息id
					comms:[],//商品id
				},
				querys: {
					page: '0',
					size: '1000',
					//开始时间
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
					macs:[],//设备信息id
					comms:[],//商品id
				},
				map:{
					totalMoney:0,
					wechatMoney:0,
					wechatRefundMoney:0,
					alpayMoney:0,
					alpayRefundMoney:0,
					xiaojieMoney:0,
					xiaojieRefundMoney:0,
					xiaoshanMoney:0,
					xiaoshanRefundMoney:0,
				},
				loading:false
			}
		},
		methods: {
			
			daochu(){
				let _this=this
				_this.query.size = 100
				_this.ajaxPage()
				setTimeout(function(){
					_this.$refs.selection.exportCsv({});
				},3000)
				
				 
			},
			xiangqing(item){
				let _this=this
				this.$router.push({
					name: 'oper/finance/list',
					query: {
						macId: item.id,
						kaishi:_this.query.kaishiTime+'',
						jieshu:_this.query.jieshuTime+''
					}
				})
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				_this.query.kaishiTime=time
			    //this.queryOperStatistics()
			},
			onchangeJieshu(time){
				let _this=this
				_this.query.jieshuTime=time
			    //this.queryOperStatistics()
			},
			onok(){
				let _this=this
				_this.query.page=0
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){
				//if(true){
					if(ks >=js){
						_this.$Message.error('开始时间必须小于结束时间!');
					}else{
						this.showPage = false
						this.$nextTick(() => {
							this.showPage = true
						}) 
						_this.ajaxPage()
						_this.queryOperStatistics()
					}
					
				}else{
					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}
			},
			onclear(){
				let _this=this
				_this.query.page=0
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){
					this.showPage = false
					this.$nextTick(() => {
						this.showPage = true
					}) 
					_this.ajaxPage()
					_this.queryOperStatistics()
				}else{
					
					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}
			},
			onchangeSousuo(){
				
				let _this=this
				_this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			    this.queryOperStatistics()
			},
			//查询条件
			aisle(row) { //货道商品信息
				this.$router.push({
					name: 'oper/mac/aisle/list',
					query: {
						id: row.id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/oper/mac',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.operMac.totalElements
						_this.data6 = data.operMac.list
						console.log(data)
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryOperStatistics(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/oper/statistics',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.map = data.map
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryMacs(){
				let _this=this
				// _this.query.size = 1000
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/oper',
				    data: _this.querys,
					_this: _this,
					success: function(data) {
						let items = data.macFaultDetailss.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].macCode
							_this.macs.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			}
		},
		components: {
			page
		},
		created() {
			let _this=this
			var date = new Date();
			let year=parseInt(date.getFullYear()); //获取完整的年份(4位)
			let month=parseInt(date.getMonth())+1; //获取当前月份(0-11,0代表1月)
			let day=parseInt(date.getDate()); //获取当前日(1-31)
			_this.kaishi=year+'-'+month+'-'+day+' 00:00:00'
			_this.jieshu=year+'-'+month+'-'+day+' 23:59:59'
			_this.query.kaishiTime=year+'-'+month+'-'+day+' 00:00:00'
			_this.query.jieshuTime=year+'-'+month+'-'+day+' 23:59:59'
			// if(month==12){
			// 	year=year+1
			// 	month=1
			// 	_this.jieshu=year+'-'+month+'-'+'1'+' 00:00:00'
			//     _this.query.jieshuTime=year+'-'+month+'-'+'1'+' 00:00:00'
			// }else{
			// 	month=month+1
			// 	_this.jieshu=year+'-'+month+'-'+'1'+' 00:00:00'
			// 	_this.query.jieshuTime=year+'-'+month+'-'+'1'+' 00:00:00'
			// }
			this.ajaxPage()
			this.queryOperStatistics()
			this.queryMacs()
		},
		activated(){
			this.ajaxPage();
		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = false;
			next();
		},  
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		width: 100%;
		display: flex;
		margin:10px 0;
		.item{
		    //margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/finance/listMac.vue